function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnMenuList = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 186",
  style: {
    fill: "none"
  },
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 0h-9A4.505 4.505 0 0 0 2 4.5v12.6a4.505 4.505 0 0 0 4.5 4.5h9a4.505 4.505 0 0 0 4.5-4.5V4.5A4.505 4.505 0 0 0 15.5 0zM6.95 4.05A1.35 1.35 0 1 1 5.6 5.4a1.35 1.35 0 0 1 1.35-1.35zm0 13.5A1.35 1.35 0 1 1 8.3 16.2a1.35 1.35 0 0 1-1.35 1.35zm1.228-5.381a1.477 1.477 0 0 1-1.048.431 1.5 1.5 0 0 1-1.064-.438l-.613-.589a.9.9 0 0 1 1.247-1.3l.425.409L8.8 9.05a.9.9 0 1 1 1.255 1.291l-1.877 1.83zM15.5 17.1H11a.9.9 0 0 1 0-1.8h4.5a.9.9 0 1 1 0 1.8zm0-5.4h-2.7a.9.9 0 1 1 0-1.8h2.7a.9.9 0 1 1 0 1.8zm0-5.4H11a.9.9 0 0 1 0-1.8h4.5a.9.9 0 1 1 0 1.8z",
  transform: "translate(3 3)",
  style: {
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnMenuList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "4497665558c72fbc37033bc408ff766f.svg";